import { useParams } from 'react-router-dom'
import { getRouteBasePath } from '@renderer/utils/navigationUtils'

/**
 * Prefix for any URL built inside `View`: `/hub/{hubId}` on a hub route,
 * `/{projectId}` on a project route.
 *
 * `View` is mounted by both `HubRoute` and `ProjectRoute`, and only the latter
 * has a `:projectId` param — so every hard-coded `/${projectId}/...` inside it
 * resolves to `/undefined/...` while a hub is on screen.
 */
export function useRouteBasePath(): string {
  const { projectId, hubId } = useParams()
  return getRouteBasePath({ hubId, projectId })
}
